import { useGetSalesPointsQuery } from 'Services/ServiceProviderManagement/Features/SalesPoint/salesPointApi'
import type { FetchSalesPointListParams } from 'Services/ServiceProviderManagement/Features/SalesPoint/types'
import { ROWS_PER_PAGE_DEFAULT, SORT_ORDER_ASC } from 'Util/constants'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

export const SELECTED_SALES_POINT_PARAMETER_KEY = 'selectedSalesPoint'

function useSalesPointsWithParams() {
  const [searchParams, setSearchParams] = useSearchParams()

  const [searchQueryParams, setSearchQueryParams] = useState<FetchSalesPointListParams>({
    active:
      searchParams.get('active') === 'true'
        ? true
        : searchParams.get('active') === 'false'
          ? false
          : undefined,
    name: searchParams.get('name') ?? undefined,
    service_provider_id: searchParams.get('service_provider_id') ?? undefined,
    search_text: searchParams.get('search_text') ?? undefined,
    sort_by: searchParams.get('sort_by') ?? 'salesPointId',
    sort_order: searchParams.get('sort_order') ?? SORT_ORDER_ASC,
    start_index: searchParams.get('start_index') ?? undefined,
    count: ROWS_PER_PAGE_DEFAULT
  })

  const selectedSalesPointQueryParam =
    searchParams.get(SELECTED_SALES_POINT_PARAMETER_KEY) ?? undefined
  const [selectedSalesPointId, setSelectedSalesPointId] = useState(selectedSalesPointQueryParam)

  const {
    data: { resources: salesPoints } = { resources: [] },
    data: { total_results: totalResults } = { total_results: 0 },
    isFetching
  } = useGetSalesPointsQuery(searchQueryParams)

  const setQueryParams = () => {
    Object.entries(searchQueryParams).forEach(([key, value]) => {
      if (value) {
        searchParams.set(key, value.toString())
      } else {
        searchParams.delete(key)
      }
    })

    selectedSalesPointId &&
      searchParams.set(SELECTED_SALES_POINT_PARAMETER_KEY, selectedSalesPointId)

    setSearchParams(searchParams)
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: not needed because we only want to run this when params change
  useEffect(() => {
    setQueryParams()
  }, [searchQueryParams])

  // biome-ignore lint/correctness/useExhaustiveDependencies: not needed because we only want to run this when selectedSalesPointId changes
  useEffect(() => {
    if (selectedSalesPointId) {
      setQueryParams()
    } else {
      searchParams.delete(SELECTED_SALES_POINT_PARAMETER_KEY)
      setSearchParams(searchParams)
    }
  }, [selectedSalesPointId])

  return {
    salesPoints,
    isFetching,
    searchQueryParams,
    setSearchQueryParams,
    totalResults,
    selectedSalesPointId,
    setSelectedSalesPointId
  }
}

export default useSalesPointsWithParams
